import { render, staticRenderFns } from "./Return_to_office.vue?vue&type=template&id=56e1d52a"
import script from "./Return_to_office.vue?vue&type=script&lang=js"
export * from "./Return_to_office.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports